import { render, staticRenderFns } from "./sfc-logo-blue.vue?vue&type=template&id=7fb60b56&scoped=true&lang=pug&"
import script from "./sfc-logo-blue.vue?vue&type=script&lang=js&"
export * from "./sfc-logo-blue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb60b56",
  null
  
)

export default component.exports